import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "../../actions/actions";
import { listarCategoriaContaBanco } from "../../../services/categoriaContaBancoService";
import { CategoriaContaBancoModel } from "../../../models/categoriaContaBanco/categoriaContaBancoModel";

export interface CategoriaContaBancoState {
  //buscar categoria conta banco
  loading: boolean;
  list: CategoriaContaBancoModel[];
}

const initialState: CategoriaContaBancoState = {
  //buscar categoria conta banco
  loading: false,
  list: [],
};

export const categoriaContaBancoSlice = createSlice({
  name: "categoriaContaBanco",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar categoria conta banco
    builder.addCase(listarCategoriaContaBanco.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarCategoriaContaBanco.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarCategoriaContaBanco.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = categoriaContaBancoSlice.actions;

export default categoriaContaBancoSlice.reducer;
